import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { useNavigate } from 'react-router';
// import history from '../../history';
import {I18n, Translate} from 'react-redux-i18n';

import auth from '../../auth';
import Loading from '../../components/Loading/Loading';
import ExerciseBenchmarkList from '../ExerciseBenchmark/List';
import style from './Exercises.module.css';

import {
  selectExercise as selectExerciseAction,
  deleteExercise as deleteExerciseAction,
  changeFilter as changeFilterAction,
  fetchExercises as fetchExercisesAction,
} from './ExercisesActions';

import {
  fetchCompanies as fetchCompaniesAction,
} from '../Users/UsersActions';

import {
  openSocketConnection as openSocketConnectionAction,
} from '../Socket/SocketActions';
import helpers from '../../helpers';

const formatDate = (d) => {
  const dt = new Date(d);
  const options = {
    weekday: 'long',
    hour: '2-digit',
    minute: '2-digit',
  };

  return dt.toLocaleTimeString('en-us', options);
};

function Exercises(props) {
  const { 
    connected, 
    companies, 
    exercises, 
    loading, 
    selected,
    openSocketConnection,
    fetchCompanies,
    changeFilter: changeFilterProp,
    fetchExercises,
    filter: filterProp,
    selectExercise,
    deleteExercise
  } = props;

  const navigate = useNavigate();

  // componentWillMount equivalent
  useEffect(() => {
    if (!connected) {
      openSocketConnection();
    }
  }, [connected, openSocketConnection]);

  // componentDidMount equivalent
  useEffect(() => {
    if (auth.can('exercise-master')) {
      const companyPromise = fetchCompanies();
      // this switch to master's company, but we want default to All
      // changeFilterProp('company', helpers.getUserFromLocalStorage().company._id);
      changeFilterProp('company', 'all');
      
      companyPromise.then(() => {
        setTimeout(() => { fetchExercises(filterProp) }, 1500);
      });
    } else {
      fetchExercises(filterProp);
    }
  }, []); // Empty dependency array for DidMount

  function changeFilter(e) {
    changeFilterProp(e.target.id, e.target.value);
    setTimeout(() => { fetchExercises(filterProp) }, 0);
  }

  function filter() {
    fetchExercises(filterProp);
  }

  function join() {
    navigate(`/exercises/${selected}`);
  }

  function handleSelectChange(_id) {
    selectExercise(_id);
  }

  function create() {
    navigate('/exercisescreate');
  }

  function deleteFn() {
    deleteExercise(selected);
  }

  const { name, company } = filterProp;
  const user = auth.getUser();

  const selectedExercise = exercises.find(exercise => exercise.id === selected);
  const isMaster = auth.can('exercise-master');

  return (
    <div className="row">
      <div className="col-md-12 mt-4">
        {/*{ (!connected || loading) && <Loading message="Connecting to the exercises service..." /> }*/}
        <h3><strong>
          <Translate value="exercises.title"/>
        </strong></h3>
        <hr />
          <Translate value="exercises.desc"/>
        <div className="col-sm-12" style={{marginTop: 10, paddingLeft: 0}}>
          <button className="btn btn-primary" onClick={create} disabled={loading}>
            <i className="fas fa-plus" /> <Translate value="exercises.create"/>
          </button>
        </div>
        <div className="col-sm-12" style={{marginTop: 10, paddingLeft: 0}}>
          {
            (()=>{
              if (!user || !user.company) {
                // there is some bug that is resulting in calling this routine with no user, so error
                // gets thrown.
                return "";
              }
              if(user.company.maxExercises === 0) {
                return <Translate value="controls.noExcercisesAllowed" />
              } else {
                if((exercises || []).length === 0) {
                  return <Translate value="controls.NoneRunning" />
                } else {
                  if((exercises || []).length === user.company.maxExercises) {
                    return<Translate value="controls.MaxRunCount" />
                  } else {
                    return (
                      <strong>
                        <Translate value="controls.RunCount.running" />
                        {(exercises || []).length}
                        <Translate value="controls.RunCount.of" />
                        {user.company.maxExercises}
                        <Translate value="controls.RunCount.exercises" />
                      </strong>
                    )
                  }
                }
              }
            })()
          }
        </div>
        <div className="row">
          <div className="col-sm-12">
            { isMaster &&
              <div className={style.filterWrapper}>
                <p className={style.title}><Translate value="controls.Filters"/></p>
                <div className={style.filter}>
                  <div className="d-flex align-items-center gap-2">
                    <div className="mb-3">
                      <label className="control-label" htmlFor="name"><Translate value="createExercise.Name"/></label>
                      <input
                        type="text"
                        className="form-control"
                        id="name"
                        value={name}
                        onChange={changeFilter}
                      />
                    </div>
                    <div className="mb-3">
                      <label className="control-label" htmlFor="name"><Translate value=""/></label>
                      <select
                        id="company"
                        className='form-control'
                        value={company}
                        onChange={changeFilter}
                        style={{ padding: '2px 6px', fontSize: '0.8rem'}}
                      >
                        <option value="all">{ I18n.t('controls.All') }</option>
                        { (companies || []).map(cmp =>
                          <option value={cmp._id} key={cmp._id}>{cmp.name}</option>)
                        }
                      </select>
                    </div>
                    <div className="flex-grow-1">
                      <button className="btn btn-primary float-end" onClick={filter}>
                        <Translate value="controls.Refresh"/>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
        <div className="row">
          <div className="col-sm-6 column">
            <div className="col-sm-7">
              <h4>
                <strong><i className={loading ? 'fas fa-spin fa-circle-o-notch' : '' } /> <Translate value="exercises.CurrentExcs"/>:</strong>
              </h4>
              <div
                className={'select-box'}
                style={{height: '115px'}}
              >
                { (exercises || []).map(exercise => {
                  let exerciseLabel = exercise.name;
                  if (company === 'all' && companies) {
                    let companyTitle = companies.find(cmp => cmp._id === exercise.companyId)?.name;
                    exerciseLabel += ` [${companyTitle}]`;
                  }
                  return <div
                    key={exercise.id}
                    className={'select-box__variant ' + (selected === exercise.id ? 'select-box__variant--selected': '')}
                    onClick={() => handleSelectChange(exercise.id)}
                  >
                    {exerciseLabel}
                  </div>
                })
                }
              </div>

            </div>
            <div className="col-sm-7">
              { selectedExercise && (
                <div>
                  <h4><strong><Translate value="exercises.ExcsInfo"/>:</strong></h4>
                  <div className={style.exerciseInfo}>
                    <ul className={style.ul}>
                      <li><strong><Translate value="exercise.ExcsInfo"/>:</strong> {selectedExercise.name} </li>
                      <li><strong><Translate value="exercise.Scenario"/>:</strong> {selectedExercise.scenario} </li>
                      <li><strong><Translate value="exercise.Users"/>:</strong> {selectedExercise.users} </li>
                      <li><strong><Translate value="exercise.Status"/>:</strong> {selectedExercise.status} </li>
                      <li><strong><Translate value="exercise.Code"/>:</strong> {selectedExercise.code} </li>
                      <li><strong><Translate value="exercise.CreatedAt"/>:</strong> {formatDate(selectedExercise.createdAt)} </li>
                    </ul>
                  </div>
                </div>
              )}
            </div>
            <div className="col-sm-7">
              <button
                className="btn btn-primary"
                onClick={join}
                disabled={!selected || loading}
              >
                <i className="fas fa-sign-in" /> <Translate value="exercises.Join"/>
              </button>
              <button
                className={`btn btn-danger ${style.remove}`}
                onClick={deleteFn}
                disabled={!selected || loading}
              >
                <i className="fas fa-trash" /> <Translate value="controls.Delete"/>
              </button>
            </div>
          </div>
          <div className="col-sm-6" style={{paddingLeft: 10, marginLeft: 10, borderLeft: '1px solid #eee'}}>
            <ExerciseBenchmarkList />
          </div>
        </div>
      </div>
    </div>
  );
}

Exercises.propTypes = {
  connected: PropTypes.bool,
  loading: PropTypes.bool,
  selected: PropTypes.string,
  filter: PropTypes.object,
  companies: PropTypes.array,
  exercises: PropTypes.array,
  selectExercise: PropTypes.func,
  deleteExercise: PropTypes.func,
  openSocketConnection: PropTypes.func,
  fetchCompanies: PropTypes.func,
  changeFilter: PropTypes.func,
  fetchExercises: PropTypes.func,
};

const mapStateToProps = state => ({
  loading: state.exercises.loading || state.exercises.loadingCompanies,
  selected: state.exercises.selected,
  exercises: state.exercises.data,
  companies: state.exercises.companies,
  filter: state.exercises.filter,
  connected: state.socket.connected,
});

const mapDispatchToProps = {
  selectExercise: selectExerciseAction,
  openSocketConnection: openSocketConnectionAction,
  deleteExercise: deleteExerciseAction,
  fetchCompanies: fetchCompaniesAction,
  changeFilter: changeFilterAction,
  fetchExercises: fetchExercisesAction,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Exercises);

